import { render, staticRenderFns } from "./GuestList.vue?vue&type=template&id=2868edf7&scoped=true&"
import script from "./GuestList.vue?vue&type=script&lang=js&"
export * from "./GuestList.vue?vue&type=script&lang=js&"
import style0 from "./GuestList.vue?vue&type=style&index=0&id=2868edf7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2868edf7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {
  VCard,
  VDivider,
  VFlex,
  VIcon,
  VList,
  VToolbar,
  VToolbarTitle,
})
